/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";[_nghost-%COMP%]{height:100%;display:block}.main-toolbar__title[_ngcontent-%COMP%]{padding:15px;background-color:#c5d1de;color:#546373;font-weight:700;height:50px;font-size:16px}.app-accordion[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
